import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./registrationfrom.css";
// import FormInputs from "./FormInputs";
// import DropDown from "./Dropdown";
import DropDown from "../../Components/Shared/Dropdown/Dropdown";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
import EditIcon from "../../Assets/Images/EployeeRegistration/edit_icon.png";
import { fetchSchoolNameData } from "../../Redux/StudentRegistration/schoolSlice";
import { fetchClassData } from "../../Redux/StudentRegistration/classSlice";
import { fetchMediumData } from "../../Redux/StudentRegistration/mediumSlice";
import { fetchBoardData } from "../../Redux/StudentRegistration/boardSlice";
import SchoolSearch from "./SchoolSearch";

function EducationDetails({ setEducationDetails }) {
  const dispatch = useDispatch();
  const { schoolnamedata } = useSelector((state) => state.schoolname);
  const { classData } = useSelector((state) => state.classname);
  const { mediumData } = useSelector((state) => state.medium);
  const { boardData } = useSelector((state) => state.board);
  const [isOpen, setIsOpen] = useState(false);
  const [values, setValues] = useState({
    last_school_id: null,
    current_class_id: 0,
    education_medium_id: 0,
    board_id_5: null,
    pass_year_5: "",
    school_name_5: "",
    percentage_cgpa_5: "",
    board_id_6: null,
    pass_year_6: "",
    school_name_6: "",
    percentage_cgpa_6: "",
    board_id_7: null,
    pass_year_7: "",
    school_name_7: "",
    percentage_cgpa_7: "",
    board_id_8: null,
    pass_year_8: "",
    school_name_8: "",
    percentage_cgpa_8: "",
    board_id_9: null,
    pass_year_9: "",
    school_name_9: "",
    percentage_cgpa_9: "",
    board_id_10: null,
    pass_year_10: "",
    school_name_10: "",
    percentage_cgpa_10: "",
    board_id_11: null,
    pass_year_11: "",
    school_name_11: "",
    percentage_cgpa_11: "",
    board_id_12: null,
    pass_year_12: "",
    school_name_12: "",
    percentage_cgpa_12: "",
  });

  const [selectedSchoolName, setSelectedSchoolName] = useState(''); // New state for tracking selected school name

  const handleSchoolSelect = (school) => {
    setValues({ ...values, last_school_id: school.school_id }); // Set the school ID in values
    setSelectedSchoolName(school.school_name); // Update the selected school name
    setEducationDetails((prevInfo) => ({
      ...prevInfo,
      last_school_id: school.school_id, // Pass the school ID to parent component
    }));
  };

  setEducationDetails(values);

  useEffect(() => {
    dispatch(fetchSchoolNameData());
    dispatch(fetchClassData());
    dispatch(fetchMediumData());
    dispatch(fetchBoardData());
  }, [dispatch]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
    setEducationDetails((prevInfo) => ({ ...prevInfo, [name]: value }));
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="personal-info">
      <div className="personal-header">
        <div className="header">
          <h2>EDUCATION DETAIL</h2>
          <img src={EditIcon} alt="icon" />
        </div>
        <div className="accordion-btn" onClick={toggleAccordion}>
          {isOpen ? (
            <div className="minus"></div>
          ) : (
            <div className="plus">+</div>
          )}
        </div>
      </div>
      {isOpen && schoolnamedata && classData && mediumData && boardData && (
        <div className="accordion-content">
          <div className="grid-container-education">
            <div className="selecte-dropdown-items">
              {/* <DropDown
                label="School Name"
                setSelected={(selectedOption) =>
                  setValues({ ...values, last_school_id: selectedOption })
                }
                options={schoolnamedata.map((schname) => ({
                  label: schname.school_name,
                  id: schname.school_id,
                }))}
                Height="200px"
                OverFlow="auto"
              /> */}
              {/* <label htmlFor="" style={{ fontSize: "14px" }}>
                School Name
              </label>
              <div className="aur-search-dropbtn" style={{ width: "100%", backgroundColor:"white" }}>
                <input
                  type="text"
                  placeholder="Type here to search..."           
                  style={{ padding: "10px", width: "91%", height: "30px" }}
                />
                <button
                  // onClick={()=>{onSearch("")}}
                  style={{
                    backgroundColor: "white",
                    border: "none",
                    height: "25px",
                    marginTop: "4px",
                  }}
                >
                  <img src={dropdownicon} alt="" />
                </button>
              </div> */}
              <SchoolSearch onSchoolSelect={handleSchoolSelect}/>
            </div>
            <div className="grid-item">
              <div className="selecte-dropdown-items">
                <DropDown
                  label="Class ( 2025 - 2026 )"
                  setSelected={(selectedOption) =>
                    setValues({ ...values, current_class_id: selectedOption })
                  }
                  options={classData.map((cls) => ({
                    label: cls.class_name,
                    id: cls.class_id,
                  }))}
                  isRequired={true}
                />
              </div>
            </div>
            <div className="grid-item">
              <div className="selecte-dropdown-items">
                <DropDown
                  label="Medium of education"
                  setSelected={(selectedOption) =>
                    setValues({
                      ...values,
                      education_medium_id: selectedOption,
                    })
                  }
                  options={mediumData.map((med) => ({
                    label: med.medium_desc,
                    id: med.medium_id,
                  }))}
                  isRequired={true}
                />
              </div>
            </div>
          </div>
          <span className="academic-recod-title">Academic record:</span>
          <div className="academic-recode-container">
            <div className="academic-tile">CLASS</div>
            <div className="academic-tile">BOARD</div>
            <div className="academic-tile">YEAR</div>
            <div className="academic-tile">SCHOOL NAME</div>
            <div className="academic-tile">%</div>

            <div className="class-name">V</div>
            <div className="data">
              <div className="selecte-dropdown-items">
                <DropDown
                  setSelected={(selectedOption) =>
                    setValues({ ...values, board_id_5: selectedOption })
                  }
                  options={boardData.map((bod) => ({
                    label: bod.edu_board_name,
                    id: bod.edu_board_id,
                  }))}
                />
              </div>
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="pass_year_5"
                value={values.pass_year_5}
                onChange={onChange}
                maxLength={4}
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="school_name_5"
                value={values.school_name_5}
                onChange={onChange}
                // maxlength={100}
                pattern="[A-Za-z, ]{1,50}"
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="percentage_cgpa_5"
                value={values.percentage_cgpa_5}
                onChange={onChange}
                maxlength={2}
                pattern="[0-9]{1,50}"
              />
            </div>

            <div className="class-name">VI</div>
            <div className="data">
              <div className="selecte-dropdown-items">
                <DropDown
                  setSelected={(selectedOption) =>
                    setValues({ ...values, board_id_6: selectedOption })
                  }
                  options={boardData.map((bod) => ({
                    label: bod.edu_board_name,
                    id: bod.edu_board_id,
                  }))}
                />
              </div>
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="pass_year_6"
                value={values.pass_year_6}
                onChange={onChange}
                maxLength={4}
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="school_name_6"
                value={values.school_name_6}
                onChange={onChange}
                maxlength={100}
                pattern="[A-Za-z, ]{1,50}"
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="percentage_cgpa_6"
                value={values.percentage_cgpa_6}
                onChange={onChange}
                maxlength={2}
                pattern="[0-9]{1,50}"
              />
            </div>

            <div className="class-name">VII</div>
            <div className="data">
              <div className="selecte-dropdown-items">
                <DropDown
                  setSelected={(selectedOption) =>
                    setValues({ ...values, board_id_7: selectedOption })
                  }
                  options={boardData.map((bod) => ({
                    label: bod.edu_board_name,
                    id: bod.edu_board_id,
                  }))}
                />
              </div>
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="pass_year_7"
                value={values.pass_year_7}
                onChange={onChange}
                maxLength={4}
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="school_name_7"
                value={values.school_name_7}
                onChange={onChange}
                maxlength={100}
                pattern="[A-Za-z, ]{1,50}"
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="percentage_cgpa_7"
                value={values.percentage_cgpa_7}
                onChange={onChange}
                maxlength={2}
                pattern="[0-9]{1,50}"
              />
            </div>

            <div className="class-name">VIII</div>
            <div className="data">
              <div className="selecte-dropdown-items">
                <DropDown
                  setSelected={(selectedOption) =>
                    setValues({ ...values, board_id_8: selectedOption })
                  }
                  options={boardData.map((bod) => ({
                    label: bod.edu_board_name,
                    id: bod.edu_board_id,
                  }))}
                />
              </div>
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="pass_year_8"
                value={values.pass_year_8}
                onChange={onChange}
                maxLength={4}
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="school_name_8"
                value={values.school_name_8}
                onChange={onChange}
                maxlength={100}
                pattern="[A-Za-z, ]{1,50}"
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="percentage_cgpa_8"
                value={values.percentage_cgpa_8}
                onChange={onChange}
                maxlength={2}
                pattern="[0-9]{1,50}"
              />
            </div>

            <div className="class-name">IX</div>
            <div className="data">
              <div className="selecte-dropdown-items">
                <DropDown
                  setSelected={(selectedOption) =>
                    setValues({ ...values, board_id_9: selectedOption })
                  }
                  options={boardData.map((bod) => ({
                    label: bod.edu_board_name,
                    id: bod.edu_board_id,
                  }))}
                />
              </div>
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="pass_year_9"
                value={values.pass_year_9}
                onChange={onChange}
                maxLength={4}
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="school_name_9"
                value={values.school_name_9}
                onChange={onChange}
                maxlength={100}
                pattern="[A-Za-z, ]{1,50}"
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="percentage_cgpa_9"
                value={values.percentage_cgpa_9}
                onChange={onChange}
                maxlength={2}
                pattern="[0-9]{1,50}"
              />
            </div>
            <div className="class-name">X</div>
            <div className="data">
              <div className="selecte-dropdown-items">
                <DropDown
                  setSelected={(selectedOption) =>
                    setValues({ ...values, board_id_10: selectedOption })
                  }
                  options={boardData.map((bod) => ({
                    label: bod.edu_board_name,
                    id: bod.edu_board_id,
                  }))}
                />
              </div>
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="pass_year_10"
                value={values.pass_year_10}
                onChange={onChange}
                maxLength={4}
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="school_name_10"
                value={values.school_name_10}
                onChange={onChange}
                maxlength={100}
                pattern="[A-Za-z, ]{1,50}"
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="percentage_cgpa_10"
                value={values.percentage_cgpa_10}
                onChange={onChange}
                maxlength={2}
                pattern="[0-9]{1,50}"
              />
            </div>

            <div className="class-name">XI</div>
            <div className="data">
              <div className="selecte-dropdown-items">
                <DropDown
                  setSelected={(selectedOption) =>
                    setValues({ ...values, board_id_11: selectedOption })
                  }
                  options={boardData.map((bod) => ({
                    label: bod.edu_board_name,
                    id: bod.edu_board_id,
                  }))}
                />
              </div>
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="pass_year_11"
                value={values.pass_year_11}
                onChange={onChange}
                maxLength={4}
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="school_name_11"
                value={values.school_name_11}
                onChange={onChange}
                maxlength={100}
                pattern="[A-Za-z, ]{1,50}"
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="percentage_cgpa_11"
                value={values.percentage_cgpa_11}
                onChange={onChange}
                maxlength={2}
                pattern="[0-9]{1,50}"
              />
            </div>

            <div className="class-name">XII</div>
            <div className="data">
              <div className="selecte-dropdown-items">
                <DropDown
                  setSelected={(selectedOption) =>
                    setValues({ ...values, board_id_12: selectedOption })
                  }
                  options={boardData.map((bod) => ({
                    label: bod.edu_board_name,
                    id: bod.edu_board_id,
                  }))}
                />
              </div>
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="pass_year_12"
                value={values.pass_year_12}
                onChange={onChange}
                maxLength={4}
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="school_name_12"
                value={values.school_name_12}
                onChange={onChange}
                maxlength={100}
                pattern="[A-Za-z, ]{1,50}"
              />
            </div>
            <div className="data">
              <FormInputs
                type="text"
                name="percentage_cgpa_12"
                value={values.percentage_cgpa_12}
                onChange={onChange}
                maxlength={2}
                pattern="[0-9]{1,50}"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default EducationDetails;
